import React from 'react';
import { Button } from 'antd';
import s from './s.module.less';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';

const InitStep: React.FC<{ className: string; isAvailabilitySetUpCompleted: boolean; isKlarityServiceSetUpCompleted: boolean; }> = ({
    className,
    isAvailabilitySetUpCompleted,
    isKlarityServiceSetUpCompleted,
}) => {
    const navigate = useNavigate();
    return (
        <div className={`${s.wrapper} ${className}`}>
            <div className={s.content}>
                <div className={s.title}>
                    Set up services and availability
                </div>
                <div className={s.desc}>
                    Connect your calendar to avoid double bookings, reduce no-shows, and make it easy for patients to book you at the right time.
                </div>
                <div className={s.buttonWrap}>
                    <Button
                        type="primary"
                        onClick={() => {
                            if (!isKlarityServiceSetUpCompleted) {
                                // ... todo
                                navigate(
                                    `/${PATH.SERVICE_SETTING}`,
                                );
                                return;
                            }
                            navigate(
                                `${PATH.DASHBOARD}/${PATH.CALENDAR}`,
                            );
                        }}
                    >
                        { !isKlarityServiceSetUpCompleted ? 'Set up now' : 'Set up availability' }
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default InitStep;
